module.exports = __webpack_public_path__ + "img/ios_icon.67cf3118.png";